import { Route } from 'vue-router';

import { TableName } from '@/enums/tableName';
import store from '@/store/store';
import { prepareQuery } from './prepareQuery';

/**
 * Pobiera listę faktur
 *
 * @export
 * @param {Route} route
 * @returns
 */
export function getInvoicesList(route: Route) {
  return store.dispatch('invoice/list', {
    ...prepareQuery(route),
    entityType: TableName.document,
    entityId: route.params.documentId.toString(),
    count: -1
  });
}
